import React from "react";
import { Link } from "react-router-dom";

import { isPublicAbsoluteHttpUrl, resolvePublicNavHrefFull } from "./xoPublicSurfaceUrls";

type PublicSurfaceLinkProps = {
  to: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  replace?: boolean;
};

/**
 * Same-origin uses React Router; absolute `https?://` uses a real navigation anchor.
 */
export function PublicSurfaceLink(props: PublicSurfaceLinkProps): React.ReactElement {
  const href = resolvePublicNavHrefFull(props.to);
  if (isPublicAbsoluteHttpUrl(href)) {
    return (
      <a href={href} rel="noreferrer" className={props.className} style={props.style}>
        {props.children}
      </a>
    );
  }
  return (
    <Link to={href} replace={props.replace} className={props.className} style={props.style}>
      {props.children}
    </Link>
  );
}
